import { NOTIFICAR } from "../redux/actions/actionsConstants";

const ERROR_PAYLOAD = {
  variant: "error",
  estilo: "error",
};

function notificarErro(dispatch, mensagem) {
  dispatch({
    type: NOTIFICAR,
    payload: {
      mensagem,
      ...ERROR_PAYLOAD,
    },
  });
}

function extrairErro(error) {
  return error?.response?.data?.error || error?.data?.error || error;
}

function handleValidationError(dispatch, err, dispatchType) {
  const validationErrors = {};
  if (err?.details?.messages) {
    Object.entries(err.details.messages).forEach(([key, messages]) => {
      validationErrors[key] = messages[0];
    });
  }
  dispatch({ type: dispatchType, payload: validationErrors });
}

export default function (
  dispatch,
  error,
  mensagemErroDiferenteResponse,
  dispatchType,
  mensagemDiferenteValidationError,
) {
  if (!error?.response && !error?.data?.error?.message) {
    notificarErro(dispatch, mensagemErroDiferenteResponse);
    return;
  }

  const err = extrairErro(error);

  if (err?.name === "ValidationError") {
    handleValidationError(dispatch, err, dispatchType);
  } else if (err?.message) {
    notificarErro(dispatch, err.message);
  } else {
    notificarErro(dispatch, mensagemDiferenteValidationError);
  }
}
